import { render } from "./LongPants.vue?vue&type=template&id=efd8051e"
import script from "./LongPants.vue?vue&type=script&lang=js"
export * from "./LongPants.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__